import React from "react";

// Maps an eSign envelope status to a human label + pill colour.
// Styling mirrors StatusTag.jsx (lighter bg + darker text status pills).
const STATUS_STYLES = {
  DRAFT: { label: "Preparing", cls: "bg-gray-100 text-gray-600" },
  CREATED: { label: "Awaiting signature", cls: "bg-amber-100 text-amber-800" },
  IN_PROGRESS: { label: "Signing in progress", cls: "bg-blue-100 text-blue-800" },
  PARTIALLY_SIGNED: { label: "Signing in progress", cls: "bg-blue-100 text-blue-800" },
  COMPLETED: { label: "Signed", cls: "bg-green-100 text-green-800" },
  DECLINED: { label: "Declined", cls: "bg-red-100 text-red-800" },
  EXPIRED: { label: "Expired", cls: "bg-gray-100 text-gray-600" },
  FAILED: { label: "Failed", cls: "bg-red-100 text-red-800" },
};

const ESignStatusBadge = ({ status }) => {
  if (!status) return null;
  const meta = STATUS_STYLES[status] || { label: status, cls: "bg-gray-100 text-gray-700" };
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-lg text-xs font-semibold ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
};

export default ESignStatusBadge;
